import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';
import { Stack } from 'components/layouts';

const useStyles = Mui.makeStyles(() => ({
  fullHeight: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function Results({
  icon,
  customIcon,
  title,
  description,
  action,
  embedded = false,
  fullHeight = false,
}) {
  const classes = useStyles();
  const fullHeightClass = fullHeight ? classes.fullHeight : undefined;

  const content = (
    <Stack>
      <Mui.Box display="flex" justifyContent="center">
        {customIcon || (
          <Mui.Icon color="secondary" style={{ fontSize: 80 }}>
            {icon}
          </Mui.Icon>
        )}
      </Mui.Box>

      <Mui.Typography variant="h4" align="center">
        {title}
      </Mui.Typography>
      <Mui.Typography variant="body1" align="center">
        {description}
      </Mui.Typography>

      {action && (
        <Mui.Box display="flex" justifyContent="center">
          <Mui.Button size="large" onClick={action.onClick}>
            {action.label}
          </Mui.Button>
        </Mui.Box>
      )}
    </Stack>
  );

  if (embedded) {
    return (
      <Mui.Box py={8} px={2} className={fullHeightClass}>
        {content}
      </Mui.Box>
    );
  }

  return (
    <Mui.Paper variant="outlined" className={fullHeightClass}>
      <Mui.Box p={10}>{content}</Mui.Box>
    </Mui.Paper>
  );
}

Results.propTypes = {
  icon: PropTypes.string,
  customIcon: PropTypes.node,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.object,
  embedded: PropTypes.bool,
  fullHeight: PropTypes.bool,
};

export default Results;
